import React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import InputLabel from '@/components/form/base/InputLabel.tsx';
import InputError from '@/components/form/base/InputError.tsx';
import InputHint from '@/components/form/base/InputHint.tsx';
import PrimitiveTextarea from '@/components/form/_primitives/PrimitiveTextarea.tsx';

export const TextareaInput = ({
  label,
  register,
  placeholder,
  required = false,
  disabled = false,
  error,
  hint,
  rows = 3,
}: {
  label?: string;
  register: UseFormRegisterReturn;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  hint?: string;
  rows?: number;
}) => {
  return (
    <div className="flex w-full flex-col items-start gap-1.5">
      {label && (
        <InputLabel label={label} required={required} disabled={disabled} />
      )}
      <PrimitiveTextarea
        placeholder={placeholder}
        disabled={disabled}
        error={error}
        rows={rows}
        {...register}
      />
      <InputError error={error} />
      <InputHint hint={hint} />
    </div>
  );
};
